export default __webpack_public_path__ + "static/media/me.ed90bc21.png";